import { GRADE_COLOURS } from '~/modules/user-profiles/grade-colours';

/**
 * How many of the three dots are lit, and in what colour, per level. The colours are rungs of the
 * grade ladder rather than new ones - green, yellow, red as the level gets harder - so the row
 * agrees with every other place in the app that colours difficulty.
 *
 * The debug levels are absent on purpose: they are wider than Easy, so there is no rung below the
 * one Easy already holds, and they are only ever on when someone has turned them on from a console.
 */
const LEVELS: Record<string, { lit: number; colour: string }> = {
  Easy: { lit: 1, colour: GRADE_COLOURS.A },
  Medium: { lit: 2, colour: GRADE_COLOURS.S },
  Hard: { lit: 3, colour: GRADE_COLOURS.E },
};

interface Props {
  level: string;
  /** The selected cell is filled with the accent, on which these greens and yellows are illegible -
   * and the fill already says which level is picked. Clearing `color` lets the dots take the cell's
   * own black instead. */
  selected: boolean;
}

export default function DifficultyDots({ level, selected }: Props) {
  const spec = LEVELS[level];
  if (!spec) return null;

  return (
    <svg
      viewBox="0 0 34 12"
      aria-hidden
      className="h-[0.75rem] w-[2.125rem] shrink-0"
      // `currentColor` on the circles only, so the label beside them stays white.
      style={selected ? undefined : { color: spec.colour }}>
      {[6, 17, 28].map((cx, index) => (
        <circle key={cx} cx={cx} cy={6} r={5} fill="currentColor" opacity={index < spec.lit ? undefined : 0.28} />
      ))}
    </svg>
  );
}
